export const UNLU_KATEGORI_DATA = {
    "siyasiler": [
      "Cumhurbaşkanı",
      "Cumhurbaşkanı Yardımcısı",
      "Bakan",
      "Bakan Yardımcısı",
      "Milletvekili",
      "TBMM Komisyon Başkanı",
      "TBMM Grup Başkanı",
      "TBMM Grup Başkanvekili",
      "Büyükşehir Belediye Başkanı",
      "Belediye Başkanı",
      "Belediye Başkan Yardımcısı",
      "Belediye Meclis Üyesi",
      "İl Genel Meclisi Üyesi",
      "Parti Genel Başkanı",
      "Genel Başkan Yardımcısı",
      "Genel Sekreter",
      "MYK Üyesi (Merkez Yürütme Kurulu)",
      "MKYK Üyesi (Merkez Karar ve Yönetim Kurulu)",
      "İl Başkanı",
      "İl Başkan Yardımcısı",
      "İlçe Başkanı",
      "İlçe Başkan Yardımcısı",
      "Belde Başkanı",
      "Kadın Kolları Başkanı",
      "Gençlik Kolları Başkanı",
      "Milletvekili Adayı",
      "Belediye Başkan Adayı",
      "Meclis Üyesi Adayı",
      "Siyasi Danışman",
      "Başdanışman",
      "Parti Sözcüsü",
      "Kampanya Koordinatörü",
      "Seçim İşleri Sorumlusu",
      "Teşkilat Başkanı"
    ],
    "Ses Sanatçısı": [
      "Türk Halk Müziği",
      "Türk Sanat Müziği",
      "Türk Hafif Müziği",
      "Arabesk",
      "Fantezi",
      "Aşık / Halk Ozanı",
      "Tasavvuf Müziği",
      "Mehter / Askeri Müzik",
      "Pop",
      "Rock",
      "Rap / Hip-Hop",
      "R&B / Soul",
      "Jazz",
      "Blues",
      "Elektronik (EDM, House, Techno vb.)",
      "Indie / Alternatif",
      "Metal",
      "Çocuk Şarkıları",
      "Dini / İlahi"
    ],
    "Bürokrat": [
      "Anayasa Mahkemesi Başkanı",
      "Anayasa Mahkemesi Üyesi",
      "Ateşe",
      "Bakan Yardımcısı",
      "Baş Hekim",
      "Başkan Yardımcısı (kurumlarda)",
      "Başkonsolos",
      "Bölge Müdürü",
      "Büyükelçi",
      "Cumhurbaşkanlığı Ofis Başkanı",
      "Cumhuriyet Başsavcısı",
      "Daimi Temsilci",
      "Daire Başkanı",
      "Danıştay Başkanı",
      "Danıştay Üyesi",
      "Dekan",
      "Doçent",
      "Doktor Öğretim Üyesi",
      "Emniyet Genel Müdür Yardımcısı",
      "Emniyet Genel Müdürü",
      "Genel Müdür",
      "Genel Müdür Yardımcısı",
      "Hakim",
      "İl Emniyet Müdürü",
      "İl Müdürü",
      "il müftüsü",
      "İlçe Emniyet Müdürü",
      "İlçe Müdürü",
      "ilçe müftüsü",
      "Jandarma Komutanı (İl / İlçe)",
      "kaymakam",
      "Konsolos",
      "Kor General",
      "Kurum Başkanı (örn: SPK, BDDK vb.)",
      "Milli eğitim Müdürü",
      "Or general",
      "Özel Kalem Müdürü",
      "Profesör",
      "Rektör",
      "Sahil Güvenlik Komutanı",
      "Savcı",
      "Şube Müdürü",
      "Tüm general",
      "Vali",
      "Vali yardımcısı",
      "yargıtay başkanı",
      "Yargıtay Üyesi",
      "Muhtar"
    ],
    "Müzisyen": [
      "Bağlama",
      "Cümbüş",
      "klarnet",
      "keman",
      "piyano",
      "klavye",
      "ritm",
      "bateri",
      "Zurna - Davul  (Yöresel oyunlar)",
      "nefesli",
      "udi",
      "gitar",
      "kemençe",
      "Kanun"
    ],
    "yazar / gazeteci / şair": [
      "edebiyatçı",
      "gazeteci",
      "Halk Ozanları / Aşıklar",
      "roman ve hikayi yazarı",
      "Senaristler / Oyun Yazarı",
      "şair",
      "köşe yazarı",
      "araştırmacı gazeteci"
    ],
    "Sinema - televizyon dünyası": [
      "Dansçılar / Bale ve Modern Dans",
      "Komedyenler / Stand-up",
      "Tiyatro Oyuncu",
      "manken",
      "sunucu / spiker",
      "Animasyon ve Dijital Efekt Sanatçı",
      "Görüntü Yönetmeni",
      "Kurgu ve Post-Prodüksiyon Sanatçı",
      "Yapımcı / Prodüktör",
      "oyuncu - Yönetmen - senarist"
    ],
    "görsel sanatlar": [
      "ressam",
      "heykeltraş",
      "ebru sanatçısı",
      "hattat.",
      "Fotoğraf Sanatçısı",
      "Karikatüristler",
      "Grafik / Dijital Tasarım"
    ],
    "sporcular": [
      "Güreş",
      "Futbolcu",
      "Boksör",
      "Okçu",
      "Basketbol",
      "Voleybol",
      "Yüzücü",
      "Halter",
      "Uzak doğu sporları",
      "Dağcılık / Tırmanış",
      "Atletler (koşu, uzun atlama, cirit vb.)",
      "Jimnastikçiler",
      "Kayak",
      "Yelken / Kano / Kürek",
      "Motorsport (Motosiklet, Otomobil)",
      "Hentbolcular",
      "Teknik direktör",
      "Esksrim",
      "Binicilik",
      "Tenis",
      "Masa Tenisi",
      "Hentbol",
      "Bisiklet"
    ],
    "bilim insanları": [
      "mucit / girişimci"
    ],
    "Diğer / Alternatif Sanatlar": [
      "El Sanatları / Geleneksel Zanaatkarlar",
      "Makyaj ve Sahne Tasarımcıları",
      "Moda Tasarımcıları",
      "Multimedya / Yeni Medya Sanatçıları"
    ]
  };
  
  export const ANA_KATEGORILER = Object.keys(UNLU_KATEGORI_DATA);